@use "~theme/typography";
@use "~theme/breakpoints";

.fieldset {
  padding: 0;
  position: relative;
  border: none;
  margin: 0 0 24px;

  @include breakpoints.desktop {
    margin: 0;
  }
}

.legend {
  @include typography.body-semibold;
  margin-bottom: 8px;
  display: none;

  @include breakpoints.mobile-large {
    display: inherit;
  }

  @include breakpoints.desktop {
    position: absolute;
    top: 4px;
    text-align: right;
    width: 180px;
    margin: 0;
  }
}

.alwaysVertical {
  @include breakpoints.desktop {
    position: static;
    text-align: left;
    margin-left: 212px;
    margin-right: 124px;
    width: inherit;
  }
}

.aside {
  font-weight: var(--regular-weight);
}

.fieldGroup {
  @include breakpoints.desktop {
    margin: 0 124px 48px 212px;
  }
}

.fieldGroupCustom {
  @include breakpoints.desktop {
    margin: 0px;
  }
}